import { useState } from "react";

import { Alert } from "flowbite-react";

import { Actions } from "../reducers/Booking";
import Stepper, { STEPS } from "../components/Stepper";

import Initial from "./Initial";
import RegnumSearchForm from "../components/RegnumSearchForm";
import ConfirmVehicleDetails from "../components/ConfirmVehicleDetails";
import EditVehicleForm from "../components/EditVehicleForm";

// KY69EZL (Seat Leon) YF68KGX (Skoda Karoq) Y802KAN (Audi A4)

const Page = ({ state, dispatch, pushHash }) => {
  const [result, setResult] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const { vehicle } = state || {};
  const { regnum } = vehicle || {};

  const handleConfirm = () => {
    dispatch({
      type: Actions.SetVehicle,
      payload: { ...result },
    });
  };

  return (
    <>
      <Stepper step={STEPS.Vehicle} pushHash={pushHash} />

      {!editMode && <RegnumSearchForm onSearch={setResult} number={regnum} />}

      {!editMode && !result?.error && (
        <ConfirmVehicleDetails
          vehicle={result}
          onConfirm={handleConfirm}
          onCancel={() => setEditMode(true)}
        />
      )}

      {editMode && <EditVehicleForm state={state} onConfirm={handleConfirm} />}
      {result?.error && (
        <div className="mt-8">
          <Alert color="failure">
            {result.error.error || "Could not find vehicle details"}
          </Alert>
        </div>
      )}
    </>
  );
};

const tuple = { Page, Description: Initial.Description };

export default tuple;
